/**
 * IANA zone → a plain-English label, for the client-site "confirm the
 * timezone" readout.
 *
 * A typed address can default an hour off from what an RD expects — Knoxville
 * reads Eastern on a map but is in `America/Chicago`, and the FL panhandle and
 * west Texas have the same trap in reverse. `America/Chicago` does not say
 * "Central Time" to a non-technical reader, so the confirmation has to spell
 * it out — that legibility is the actual safety net, not the select itself.
 */
const FRIENDLY_ZONE_NAMES: Record<string, string> = {
  'America/New_York': 'Eastern Time',
  'America/Chicago': 'Central Time',
  'America/Denver': 'Mountain Time',
  'America/Phoenix': 'Mountain Time (no daylight saving)',
  'America/Los_Angeles': 'Pacific Time',
  'America/Anchorage': 'Alaska Time',
  'Pacific/Honolulu': 'Hawaii Time',
};

/** Falls back to the raw IANA name for a zone outside the map above, so an
 *  unexpected value still shows something rather than going blank. */
export function friendlyZoneName(ianaZone: string): string {
  return FRIENDLY_ZONE_NAMES[ianaZone] ?? ianaZone;
}
